import { inject, Injectable } from '@angular/core';
// environment
import { environment } from '@environments/environment';
// services
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { StorageService } from '@app/shared/services/storage.service';
import { StateManagementService } from '@app/+chat/shared/services/state-management.service';
// types
import { ICreateFireBaseResponse } from '../types/firebase-data-type';
import { FirebaseApp } from 'firebase/app';

@Injectable()
export class FirebaseService {
  private _id!: string;

  // dependencies
  private readonly _stateManagementService = inject(StateManagementService);
  private readonly _storageService = inject(StorageService);

  constructor() {}

  // initial firebase
  public requestPermission(app: FirebaseApp) {
    const messaging = getMessaging(app);
    getToken(messaging, { vapidKey: environment.firebase.vapidKey })
      .then(currentToken => {
        if (currentToken) {
          this._storageService.setFirebaseToken(currentToken);
          this.createFirebase(currentToken);
        } else {
        }
      })
      .catch(err => {});
  }

  public listen(app: FirebaseApp) {
    const messaging = getMessaging(app);
    onMessage(messaging, payload => {
      this._stateManagementService.messagesNotifications.set([payload]);
      console.log('Message received. ', payload);
    });
  }

  public createFirebase(firebase_token: string) {
    // this._apollo
    //   .mutate<ICreateFireBaseResponse>({
    //     mutation: createFirebase,
    //     variables: { firebase_token, project: environment.auth.apiId },
    //   })
    //   .subscribe({
    //     next: ({ data, loading }) => {
    //       if (data?.createFireBase) {
    //         this._id = data.createFireBase._id;
    //         this._stateManagementService.firebaseData.set(data.createFireBase);
    //       }
    //     },
    //     error: errors => {},
    //     complete: () => {},
    //   });
  }

  public removeFirebase() {
    // const firebaseToken = this._storageService.getFirebaseToken();
    // this._apollo
    //   .mutate({
    //     mutation: removeFirebase,
    //     variables: {
    //       firebase_token: firebaseToken,
    //       project: environment.auth.apiId,
    //     },
    //   })
    //   .subscribe({
    //     next: () => {
    //       this._storageService.removeFirebaseToken();
    //     },
    //   });
  }
}
